/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Content_Feature_3_TitleInputs */

const en_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Covered Practice`)
};

const es_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Práctica cubierta`)
};

const de_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überdachte Abschlagplätze`)
};

const zh_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有顶棚的练习区`)
};

const ar_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدريب مغطى`)
};

const fr_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice couvert`)
};

const vi_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luyện tập có mái che`)
};

const sw_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mazoezi chini ya paa`)
};

const th_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พื้นที่ซ้อมมีหลังคา`)
};

const bs_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natkriveni prostor za vježbanje`)
};

const ja_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`屋根付き打席`)
};

const ko_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지붕 있는 연습 타석`)
};

const pt_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino coberto`)
};

const it_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento al coperto`)
};

const sv_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täckta utslagsplatser`)
};

const nl_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdekte afslagplaatsen`)
};

const da_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdækkede udslagssteder`)
};

const nb_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overbygde utslagsplasser`)
};

const fi_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katetut lyöntipaikat`)
};

const pl_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadaszone stanowiska`)
};

const ru_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Крытая тренировочная зона`)
};

const tr_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapalı antrenman alanı`)
};

const hi_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छत वाला अभ्यास क्षेत्र`)
};

const id_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat latihan beratap`)
};

const ms_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latihan berbumbung`)
};

const cs_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krytá odpaliště`)
};

const el_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Στεγασμένες θέσεις`)
};

const he_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עמדות חבטה מקורות`)
};

const af_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oordekte afslaanplekke`)
};

const hu_range_content_feature_3_title = /** @type {(inputs: Range_Content_Feature_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedett gyakorlóhely`)
};

/**
* | output |
* | --- |
* | "Covered Practice" |
*
* @param {Range_Content_Feature_3_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_content_feature_3_title = /** @type {((inputs?: Range_Content_Feature_3_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Content_Feature_3_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_content_feature_3_title(inputs)
	if (locale === "de") return de_range_content_feature_3_title(inputs)
	if (locale === "zh") return zh_range_content_feature_3_title(inputs)
	if (locale === "ar") return ar_range_content_feature_3_title(inputs)
	if (locale === "fr") return fr_range_content_feature_3_title(inputs)
	if (locale === "vi") return vi_range_content_feature_3_title(inputs)
	if (locale === "sw") return sw_range_content_feature_3_title(inputs)
	if (locale === "th") return th_range_content_feature_3_title(inputs)
	if (locale === "bs") return bs_range_content_feature_3_title(inputs)
	if (locale === "ja") return ja_range_content_feature_3_title(inputs)
	if (locale === "ko") return ko_range_content_feature_3_title(inputs)
	if (locale === "pt") return pt_range_content_feature_3_title(inputs)
	if (locale === "it") return it_range_content_feature_3_title(inputs)
	if (locale === "sv") return sv_range_content_feature_3_title(inputs)
	if (locale === "nl") return nl_range_content_feature_3_title(inputs)
	if (locale === "da") return da_range_content_feature_3_title(inputs)
	if (locale === "nb") return nb_range_content_feature_3_title(inputs)
	if (locale === "fi") return fi_range_content_feature_3_title(inputs)
	if (locale === "pl") return pl_range_content_feature_3_title(inputs)
	if (locale === "ru") return ru_range_content_feature_3_title(inputs)
	if (locale === "tr") return tr_range_content_feature_3_title(inputs)
	if (locale === "hi") return hi_range_content_feature_3_title(inputs)
	if (locale === "id") return id_range_content_feature_3_title(inputs)
	if (locale === "ms") return ms_range_content_feature_3_title(inputs)
	if (locale === "cs") return cs_range_content_feature_3_title(inputs)
	if (locale === "el") return el_range_content_feature_3_title(inputs)
	if (locale === "he") return he_range_content_feature_3_title(inputs)
	if (locale === "af") return af_range_content_feature_3_title(inputs)
	if (locale === "hu") return hu_range_content_feature_3_title(inputs)
	return en_range_content_feature_3_title(inputs)
});